/* eslint-disable react/jsx-props-no-spreading */
// @mui
import { Box, BoxProps } from '@mui/material';
// hooks
import useResponsive from '../../hooks/useResponsive';
// config
import { HEADER, NAV } from '../../config-global';
// components
import { useSettingsContext } from '../settings/SettingsContext';
// RITA-1522
import { HEATMAP_LEISTE_PLATZ } from '../../features/usage-tracking/heatmap/leistenHoehe';

// ----------------------------------------------------------------------

const SPACING = 8;

// RITA-1522: Die Heatmap-Leiste liegt fix am unteren Fensterrand. Ohne reservierten Platz läge der
// unterste Bildbereich jeder Seite beim vollen Scrollstand hinter ihr. Der Abstand steht bewusst
// als Inline-Stil (in `sx` wäre er in jsdom nicht prüfbar) und ist ohne Overlay 0 px.
const HEATMAP_PLATZ = { marginBottom: HEATMAP_LEISTE_PLATZ };

export default function Main({ children, sx, ...other }: BoxProps) {
  const { themeLayout } = useSettingsContext();

  const isNavHorizontal = themeLayout === 'horizontal';

  const isNavMini = themeLayout === 'mini';

  const isDesktop = useResponsive('up', 'lg');

  if (isNavHorizontal) {
    return (
      <Box
        component="main"
        style={HEATMAP_PLATZ}
        sx={{
          pt: `${HEADER.H_MOBILE + SPACING}px`,
          pb: `${HEADER.H_MOBILE + SPACING}px`,
          ...(isDesktop && {
            px: 2,
            pt: `${HEADER.H_DASHBOARD_DESKTOP + 80}px`,
            pb: `${HEADER.H_DASHBOARD_DESKTOP + SPACING}px`,
          }),
        }}
      >
        {children}
      </Box>
    );
  }

  return (
    <Box
      component="main"
      style={HEATMAP_PLATZ}
      sx={{
        flexGrow: 1,
        py: `${HEADER.H_MOBILE + SPACING}px`,
        ...(isDesktop && {
          px: 2,
          py: `${HEADER.H_DASHBOARD_DESKTOP + SPACING}px`,
          width: `calc(100% - ${NAV.W_DASHBOARD}px)`,
          ...(isNavMini && {
            width: `calc(100% - ${NAV.W_DASHBOARD_MINI}px)`,
          }),
        }),
        ...sx,
      }}
      {...other}
    >
      {children}
    </Box>
  );
}
